import api from '@/lib/axios';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  return (r.data as any).data ?? (r.data as T);
}

export interface UsagePerUser {
  userId: string | null;
  userName: string;
  hits: number;
  lastHitAt: string;
}

export interface UsagePerEndpoint {
  routePattern: string;
  method: string;
  hits: number;
  avgDurationMs: number;
  lastHitAt: string;
}

export interface UsageEndpointRef {
  method: string;
  pattern: string;
  label: string;
  hits?: number;
  lastHitAt?: string;
}

export interface UsageSummary {
  range: { from: string; to: string };
  totalHits: number;
  uniqueUsers: number;
  perUser: UsagePerUser[];
  perEndpoint: UsagePerEndpoint[];
  unusedEndpoints: UsageEndpointRef[];
  totalKnownEndpoints: number;
}

export interface UserUsageSummary {
  user: { id: string; name: string; email: string | null };
  range: { from: string; to: string };
  totalHits: number;
  perEndpoint: UsagePerEndpoint[];
  usedEndpoints: UsageEndpointRef[];
  neverUsedEndpoints: UsageEndpointRef[];
  totalKnownEndpoints: number;
}

export interface UsageLogRow {
  id: string;
  userId: string | null;
  userName: string | null;
  method: string;
  path: string;
  routePattern: string;
  statusCode: number;
  durationMs: number;
  requestBody: string | null;
  responseBody: string | null;
  ip: string | null;
  createdAt: string;
}

export interface UsageLogsResult {
  data: UsageLogRow[];
  meta: { total: number; page: number; limit: number };
}

export interface UsageSummaryQuery {
  dateFrom?: string;
  dateTo?: string;
}

export interface UsageLogsQuery extends UsageSummaryQuery {
  userId?: string;
  routePattern?: string;
  page?: number;
  limit?: number;
}

export const UsageLogsApi = {
  summary: async (query: UsageSummaryQuery): Promise<UsageSummary> =>
    unwrap(await api.get('/school/usage-logs/summary', { params: query })),
  userSummary: async (userId: string, query: UsageSummaryQuery): Promise<UserUsageSummary> =>
    unwrap(await api.get(`/school/usage-logs/user/${userId}`, { params: query })),
  logs: async (query: UsageLogsQuery): Promise<UsageLogsResult> =>
    unwrap(await api.get('/school/usage-logs/logs', { params: query })),
};
